// UI constants shared across the app.

export const STATUS_META = {
  new:            { label: "New",            color: "#3B82F6" },
  not_connected:  { label: "Not Connected",  color: "#94A3B8" },
  not_receiving:  { label: "Not Receiving",  color: "#64748B" },
  not_reachable:  { label: "Not Reachable",  color: "#78716C" },
  follow_up:      { label: "Follow Up",      color: "#F59E0B" },
  interested:     { label: "Interested",     color: "#10B981" },
  site_visit:     { label: "Site Visit Scheduled", color: "#06B6D4" },
  postponed:      { label: "Postponed",      color: "#8B5CF6" },
  not_interested: { label: "Not Interested", color: "#EF4444" },
  lost:           { label: "Lost",           color: "#991B1B" },
  deal_closed:    { label: "Deal Closed",    color: "#A5915B" },
};

export const STATUS_ORDER = [
  "new",
  "not_connected",
  "not_receiving",
  "not_reachable",
  "follow_up",
  "interested",
  "site_visit",
  "postponed",
  "not_interested",
  "lost",
  "deal_closed",
];

export const TEMP_META = {
  cold: { label: "Cold" },
  warm: { label: "Warm" },
  hot:  { label: "Hot" },
};

export const formatDuration = (secs) => {
  if (!secs || secs < 1) return "0s";
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  if (m === 0) return `${s}s`;
  return `${m}m ${s}s`;
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
};

export const OPP_LEAD_STATUSES = ["follow_up", "interested", "site_visit"];
export const QUICK_LEAD_STATUSES = ["not_interested", "not_receiving", "not_reachable"];
